import { jsx as r } from "react/jsx-runtime";
import { FeatureCard as m } from "../feature-card/index.js";
import { HomeSection as t } from "../home-section/home-section.js";
import n from "react";
import { Animated as d } from "@tameeni/ui";
function h({
  children: e,
  ...o
}) {
  return /* @__PURE__ */ r(t, { ...o, children: /* @__PURE__ */ r("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-4", children: n.Children.map(e, (a, i) => /* @__PURE__ */ r(
    d.FadeIn,
    {
      className: "h-full",
      useScroll: !0,
      transition: { delay: i * 0.15 },
      children: a
    },
    i
  )) }) });
}
const u = (e) => /* @__PURE__ */ r(m, { ...e });
export {
  u as WhyTameeniCard,
  h as default
};
//# sourceMappingURL=index.js.map
